
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.766 2.859l-9.528-.012a.36.36 0 00-.358.356v.358l3.78.005c2.154 0 4.308.002 6.462.008v-.357a.36.36 0 00-.356-.358zm-3.623 3.11a.441.441 0 01.882 0v5.724a.441.441 0 01-.882 0V5.97zm-3.17 0a.441.441 0 11.883 0v5.724a.442.442 0 01-.882 0V5.97zM12 3.218l-.001.797a.441.441 0 01-.44.44h-.352l-.758 9.501C10.4 14.57 9.839 15 9.224 15H2.822c-.615 0-1.173-.428-1.225-1.04L.793 4.44H.439A.439.439 0 010 4l.001-.797a1.238 1.238 0 011.237-1.235l1.842.002c.128-.52.433-.98.863-1.3 1.148-.894 2.97-.894 4.12.002.431.321.737.783.864 1.305l1.84.003A1.237 1.237 0 0112 3.217zm-3.995-1.24a1.523 1.523 0 00-.483-.612c-.827-.644-2.209-.645-3.038 0-.21.157-.377.365-.484.605l4.005.005v.001zm2.318 2.475l-8.645-.004.797 9.44c.012.143.19.229.346.229h6.403c.158 0 .335-.087.347-.23l.752-9.435z","fill":"#6C6C6C"}})])
          )
        }
      }
    